'use strict';

/**
 * The helpers exported in this file are used to calculate
 * the period details that will appear on the pdp.
 * Copy for the details titles is not determined in these helpers.
 * These methods return only the information that will
 * appear under a detail's title.
 */

const sharedHelpers = require('./detailsSharedLogic');

/**
 * @param {object} item           - Bunsen Item model
 * @returns {object} periodModel  - the first period attribute model of an item
 */
function getPeriodModel(item) {
    const period = item.get('attributes.period');
    let periodModel;

    if (period) {
        periodModel = period.first();
    }

    return periodModel;
}

module.exports = {
    /**
     * See definition for addToContents in detailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getPeriod: function(config) {
        const { item, links } = config;
        const period = getPeriodModel(item);

        return sharedHelpers.addToContents({
            model: period,
            modelKey: 'option.name',
            links,
            linkKey: 'period',
        });
    },
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/details/helpers/detailsPeriods.es.js